/**
 * GFG-364 QA round 2026-10-14 (R2): the pure parts of Remove. The row × removes the contact
 * outright, with a no-refund confirmation first. Split out of the component so each rule is
 * testable without mounting a dialog.
 */

import { COPY } from "@/constants/campaignContacts";
import { CAMPAIGN_STATUSES } from "@/constants/campaings";
import type { CampaignStatus } from "@/types/types";
import { isRemovable, REDEEMED_STATUS } from "./campaignContacts-helper";
import type { CampaignContactRow, ContactRemoveFlow } from "./types";

/** Gifts that are over (Declined, Expired) are locked like Redeemed. */
const ENDED_STATUSES: readonly string[] = [
  CAMPAIGN_STATUSES.LINK_DECLINED,
  CAMPAIGN_STATUSES.LINK_EXPIRED,
];
const REMOVABLE_CAMPAIGN_STATUSES: readonly CampaignStatus[] = [
  CAMPAIGN_STATUSES.SCHEDULED,
  CAMPAIGN_STATUSES.ACTIVE,
  CAMPAIGN_STATUSES.CLOSED,
];

/** Which path the row × takes: refused, refused as the last recipient, the confirm, or refused. */
export function contactRemoveFlow(
  contact: CampaignContactRow,
  activeCount: number,
  allowed?: boolean,
): ContactRemoveFlow {
  if (contact.status === REDEEMED_STATUS || ENDED_STATUSES.includes(contact.status)) {
    return "blocked";
  }
  if (activeCount <= 1) return "last";
  if (allowed === false) return "blocked";
  return isRemovable(contact) ? "confirm" : "blocked";
}

/** The tooltip/toast for a refused ×, or null when the removal may be confirmed. */
export function removeBlockedReason(
  contact: CampaignContactRow,
  activeCount: number,
  allowed?: boolean,
): string | null {
  const flow = contactRemoveFlow(contact, activeCount, allowed);
  if (flow === "confirm") return null;
  if (flow === "last") return COPY.remove.blocked.last;
  return contact.status === REDEEMED_STATUS
    ? COPY.remove.blocked.redeemed(contact.name)
    : COPY.actionBlocked.removeEnded;
}

/**
 * Whether the × is drawn at all: an editor on a scheduled, active or closed, non-manual campaign.
 * A pause or close lock does not hide it; the lock refuses it with its own tooltip.
 */
export function removeVisible(i: {
  canEdit: boolean;
  status: CampaignStatus;
  manual: boolean;
}): boolean {
  return i.canEdit && !i.manual && REMOVABLE_CAMPAIGN_STATUSES.includes(i.status);
}
